exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".item-label[data-v-2a3d90ca]{font-size:1.1rem}.line-item-indent[data-v-2a3d90ca]{padding-left:1.5em}.line-item-amount[data-v-2a3d90ca]{color:#3e7c00;font-style:italic}.void-check-alert[data-v-2a3d90ca]{margin-top:1rem;padding:1.5rem;background-color:#bcdefa!important}.void-check-alert p[data-v-2a3d90ca]{color:#1c3d5a!important}.void-check-alert .small[data-v-2a3d90ca]{margin-top:1.5rem;font-size:.75rem;font-weight:100;text-align:center}.btn[data-v-2a3d90ca],.btn[data-v-2a3d90ca]:hover{color:#12283a}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2a3d90ca","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/components/accounting/accounts-payable/checks/CheckDetails.vue
// module id = ziLO
// module chunks = 0 1